module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }